module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<textarea rows="4" class="description textfield">'+
((__t=( description ))==null?'':_.escape(__t))+
'</textarea>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./menupicker/templates/cell.html
// module id = 266
// module chunks = 0